import React from "react";
import { LoginContentWrapper } from "Components";

const ConfirmReset = (): React.JSX.Element => {
  return (
    <LoginContentWrapper
      title="Reset your password"
      byline="Check your email for a password reset link. If it doesn't show up in your inbox shortly, check your spam folder."
    />
  );
};

export default ConfirmReset;
